class GelvamelRecommendations extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
        });
    }, { rootMargin: '0px 0px 400px' });
    observer.observe(this);
  }
}
if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', GelvamelRecommendations);

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.gv-collection-card, .gv-product-card, .gv-story, .gv-journal-band').forEach((element) => {
  element.classList.add('gv-reveal');
  revealObserver.observe(element);
});

